'use client';

import { useEffect } from 'react';

type ThemeName = 'light' | 'dark';

const getPreferredTheme = (): ThemeName => {
  if (typeof window === 'undefined') return 'light';
  const stored = window.localStorage.getItem('theme');
  if (stored === 'dark' || stored === 'light') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const ThemeInitializer = () => {
  useEffect(() => {
    const theme = getPreferredTheme();
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, []);

  return null;
};
